module.exports = __webpack_public_path__ + "static/4-496b0ee7c32c16da8c6289fa8aae5268.woff2";